<template>
  <div class="molded-seat-step-one">
    <v-layout justify-center>
      <v-radio-group v-model="form.type" row>
        <v-radio label="Mousse" value="FOAM" />
        <v-radio label="Rigide" value="RIGID" />
      </v-radio-group>

    </v-layout>

    <v-layout justify-center>
      <v-radio-group v-model="form.part" row>
        <v-radio label="CS" value="CS" />
        <v-radio label="Assise" value="ASSISE" />
        <v-radio label="Dossier" value="DOSSIER" />
      </v-radio-group>
    </v-layout>

    <v-layout wrap>
      <v-flex>
        <v-switch v-model="form.idc_bracket" hide-details label="Support :" class="title"
          @change="clearBracketFields" />
        <v-radio-group v-model="form.bracket" row :disabled="!form.idc_bracket">
          <v-radio label="Nouveau" value="NEW" />
          <v-radio label="Existant" value="EXISTING" />
        </v-radio-group>
      </v-flex>
    </v-layout>

    <hr class="mb-3">

    <v-layout wrap justify-space-between>
      <v-flex sm6>
        <v-radio-group v-model="form.bracket_type" :disabled="!form.idc_bracket" @change="clearOptionsFields">
          <v-radio label="SPIN" value="SPIN" />
          <v-radio label="PALMA" value="PALMA" />
          <v-radio label="FR" value="FR" />
          <v-radio label="AUTRE" value="OTHER" />
        </v-radio-group>
      </v-flex>
      <v-flex sm6>
        <div class="cadre mt-3">
          <h3 class="mb-3">
            Zone Option
          </h3>

          <div v-if="form.bracket_type === 'SPIN' || form.bracket_type === null" class="option-spin">
            <v-layout class="color-select">
              <v-select v-model="form.spin_color_id" :items="spinColors" item-text="label" item-value="id" class="mb-4"
                hide-details label="Couleur Spin" filled clearable :disabled="!form.spin_size || !form.idc_bracket"
                @click:clear="$nextTick(() => (form.spin_color_id = null))" />
              <template v-if="previewSpin">
                <v-flex v-if="previewSpin.texture == 'TEXTURE'" class="preview" style="width: 35px; height: 35px">
                  <img :src="previewSpin.image" style="width: 100%; height:100%" alt>
                </v-flex>
                <v-flex v-else-if="previewSpin.texture == 'COLOR'" class="preview" :style="previewSpinStyle" />
              </template>
            </v-layout>

            <v-select v-model="form.spin_type" :items="dropdowns.spin_type" item-text="label" item-value="value"
              class="mb-4" hide-details label="Type" filled clearable :disabled="!form.idc_bracket"
              @click:clear="$nextTick(() => (form.spin_type = null))" />
            <v-select v-model="form.spin_size" :items="dropdowns.spin_size" item-text="label" item-value="value"
              class="mb-3" hide-details label="Taille" filled clearable :disabled="!form.idc_bracket"
              @click:clear="$nextTick(() => (form.spin_size = null))" />
          </div>

          <div v-if="form.bracket_type === 'PALMA'" class="option-palma">
            <v-layout class="color-select">
              <v-select v-model="form.palma_color_id" :items="palmaColors" item-text="label" item-value="id"
                label="Couleur Palma" filled clearable :disabled="!form.idc_bracket"
                @click:clear="$nextTick(() => (form.palma_color_id = null))" />
              <template v-if="previewPalma">
                <v-flex v-if="previewPalma.texture == 'TEXTURE'" class="preview" style="width: 35px; height: 35px">
                  <img :src="previewPalma.image" style="width: 100%; height:100%" alt>
                </v-flex>
                <v-flex v-else-if="previewPalma.texture == 'COLOR'" class="preview" :style="previewPalmaStyle" />
              </template>
            </v-layout>
          </div>

          <div v-if="form.bracket_type === 'FR'" class="option-fr">
            <v-text-field v-model="form.bracket_fr" label="FR" maxlength="25" hide-details outlined class="mb-2"
              :disabled="!form.idc_bracket" />
            <v-text-field v-model.lazy="form.bracket_fr_width" v-validate="'numeric|max:4'" type="number"
              data-vv-name="(FR) Largeur" label="Largeur" class="mb-2" :class="{ error: errors.has('(FR) Largeur') }"
              :disabled="!form.idc_bracket" outlined hide-details />
            <v-text-field v-model="form.bracket_fr_depth" v-validate="'numeric|max:4'" data-vv-name="(FR) Profondeur"
              :class="{ error: errors.has('(FR) Profondeur') }" hide-details label="Profondeur" type="number" outlined
              :disabled="!form.idc_bracket" />
          </div>

          <div v-if="form.bracket_type === 'OTHER'" class="option-autre">
            <v-text-field v-model="form.bracket_other" label="Autre" hide-details maxlength="15" class="mb-2" outlined
              :disabled="!form.idc_bracket" />
            <v-text-field v-model="form.bracket_other_width" v-validate="'numeric|max:4'" data-vv-name="(Autre) Largeur"
              :class="{ error: errors.has('(Autre) Largeur') }" hide-details label="Largeur" type="number" outlined
              :disabled="!form.idc_bracket" class="mb-2" />
            <v-text-field v-model="form.bracket_other_depth" v-validate="'numeric|max:4'"
              data-vv-name="(Autre) Pronfondeur" :class="{ error: errors.has('(Autre) Pronfondeur') }" hide-details
              label="Profondeur" type="number" outlined :disabled="!form.idc_bracket" />
          </div>
        </div>
      </v-flex>

      <v-layout>
        <v-flex>
          <v-radio-group v-model="form.bracket_location" row :disabled="!form.idc_bracket">
            <v-layout sm5 class="checkbox-input-container mb-4">
              <v-flex>
                <v-radio label="Atelier" value="WORKSHOP" />
              </v-flex>
            </v-layout>

            <v-radio class="mb-4" label="Chez le patient" value="PATIENT_HOME" />

            <v-flex class="checkbox-input visible">
              <v-text-field v-model="form.bracket_serial_number" label="Numéro de série" maxlength="15" hide-details
                outlined :disabled="!form.idc_bracket" />
            </v-flex>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-layout>

    <v-layout wrap mt-4>
      <v-flex>
        <h3>CS :</h3>
        <v-layout wrap justify-space-between>
          <v-flex sm4>
            <v-checkbox v-model="form.idc_integrated_in_chair" hide-details class="mb-3"
              label="à intégrer dans le fauteuil" />
          </v-flex>
          <v-flex sm4>
            <v-checkbox v-model="form.idc_hinged_hinge" hide-details class="mb-3" label="Articulé par charnière" />
          </v-flex>
          <v-flex sm4>
            <v-checkbox v-model="form.idc_in_2_parts" hide-details class="mb-3" label="En 2 parties" />
          </v-flex>
          <v-flex sm4>
            <v-layout class="color-select">
              <v-select v-model="form.transfer_id" :items="transferColors" item-text="label" item-value="id"
                label="Transfert" filled clearable hide-details class="mb-3"
                @click:clear="$nextTick(() => (form.transfer_id = null))" />
              <template v-if="previewTransfer">
                <v-flex class="preview" style="width: 35px; height: 35px">
                  <img v-if="previewTransfer.texture == 'TEXTURE'" :src="previewTransfer.image"
                    style="width: 100%; height:100%" alt>
                </v-flex>
                <v-flex v-if="previewTransfer.texture == 'COLOR'" class="preview" :style="previewTransferStyle" />
              </template>
            </v-layout>
          </v-flex>
          <v-flex sm4>
            <v-text-field v-model="form.max_hull_width" v-validate="'numeric|max:4'" data-vv-name="Largeur max de coque"
              :class="{ error: errors.has('Largeur max de coque') }" hide-details class="mb-3"
              label="Largeur max de coque (mm)" type="number" outlined />
          </v-flex>
          <v-flex sm4>
            <v-text-field v-model="form.hull_angle" v-validate="'numeric|max:4'" data-vv-name="Angle de coque"
              :class="{ error: errors.has('Angle de coque') }" hide-details class="mb-3" label="Angle de coque (°)"
              type="number" outlined />
          </v-flex>
          <v-flex sm4>
            <v-text-field v-model="form.hardware" hide-details class="mb-3" label="Ferrure" maxlength="20" outlined />
          </v-flex>
          <v-flex sm4>
            <v-switch v-model="form.idc_symmetrical_rectif" class="ma-0" hide-details label="Rectif symétrique" />
          </v-flex>
          <v-flex sm4 />
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "MoldedSeatStepOne",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      xxlColors: "colors/getXXLType",
      lightColors: "colors/getLIGHTType",
      transferColors: "colors/getTRANSFERType",
      palmaColors: "colors/getPALMAType",

      dropdowns: "dropdowns/getMoldedSeatOptions"
    }),

    // Returns spin colors
    spinColors() {
      if (this.form.spin_size == "XXL") {
        return this.xxlColors;
      } else if (this.form.spin_size == "LIGHT") {
        return this.lightColors;
      }

      return [];
    },

    // Returns spin textures
    previewSpin() {
      return this.spinColors.find(color => color.id == this.form.spin_color_id);
    },

    // Returns spin Hex code
    previewSpinStyle() {
      if (this.previewSpin.rgb_code && this.previewSpin.rgb_code == "FFFFFF") {
        return {
          "background-color": "#" + this.previewSpin.rgb_code,
          border: "1px solid #000"
        };
      }
      return {
        "background-color": "#" + this.previewSpin.rgb_code
      };
    },

    // Returns palma textures
    previewPalma() {
      return this.palmaColors.find(
        color => color.id == this.form.palma_color_id
      );
    },

    // Returns palma Hex code
    previewPalmaStyle() {
      if (
        this.previewPalma.rgb_code &&
        this.previewPalma.rgb_code == "FFFFFF"
      ) {
        return {
          "background-color": "#" + this.previewPalma.rgb_code,
          border: "1px solid #000"
        };
      }
      return {
        "background-color": "#" + this.previewPalma.rgb_code
      };
    },

    // Returns transfer textures
    previewTransfer() {
      return this.transferColors.find(item => item.id == this.form.transfer_id);
    },

    // Returns transfer Hex Code
    previewTransferStyle() {
      if (
        this.previewTransfer.rgb_code &&
        this.previewTransfer.rgb_code == "FFFFFF"
      ) {
        return {
          "background-color": "#" + this.previewTransfer.rgb_code,
          border: "1px solid #000"
        };
      }
      return {
        "background-color": "#" + this.previewTransfer.rgb_code
      };
    }
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear bracket fields
    clearBracketFields() {
      this.form.bracket = null;
      this.form.bracket_type = null;
      this.form.spin_color_id = null;
      this.form.spin_type = null;
      this.form.spin_size = null;
      this.form.palma_color_id = null;
      this.form.bracket_fr = null;
      this.form.bracket_fr_width = null;
      this.form.bracket_fr_depth = null;
      this.form.bracket_other = null;
      this.form.bracket_other_width = null;
      this.form.bracket_other_depth = null;
      this.form.bracket_location = null;
      this.form.bracket_serial_number = null;
    },

    // Clear options fileds
    clearOptionsFields() {
      this.form.spin_color_id = null;
      this.form.spin_type = null;
      this.form.spin_size = null;
      this.form.palma_color_id = null;
      this.form.bracket_fr = null;
      this.form.bracket_fr_width = null;
      this.form.bracket_fr_depth = null;
      this.form.bracket_other = null;
      this.form.bracket_other_width = null;
      this.form.bracket_other_depth = null;
    }
  }
};
</script>

<style lang="scss">
.molded-seat-step-one {
  .checkbox-input-container {
    margin-top: 0;

    >div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: none !important;
        width: auto;

        &:not(.visible) {
          display: none;
        }

        .v-input__slot {
          margin: 0;
        }
      }
    }
  }

  .cadre {
    background-color: rgb(235, 245, 245);
    height: 200px;
    padding: 10px;
    border-radius: 4px;
  }
}
</style>
